import {VehicleForm as VFKit} from '../VehicleForm';

export function LoadingSpaceDimensionsGroup() {
  return (
    <>
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="dimensionsLoadingSpace.length"
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="dimensionsLoadingSpace.width"
      />
      <VFKit.SimpleNumericField
        decimalPlaces={2}
        forceDecimalPlaces
        name="dimensionsLoadingSpace.height"
      />
      <VFKit.SimpleNumericField decimalPlaces={2} forceDecimalPlaces name="loadingArea" />
    </>
  );
}
